import { DataScienceQuery, TaskInput } from 'dashboard-services/api/dataScience';
import { ActionService } from 'dashboard-services/services';

export default (() => {

  const ON_CHANGE = 'ON_CHANGE_TASK_LIST';
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const updateTaskMarkdown = ({ fid, taskId, updateTaskCall, queryClient }) => (_, getState) => {
    const tasks = getState().datascienceState.listState.tasksState.listState.tasks,
          task = tasks.find(t => t.id === taskId)      
      const taskInput = new TaskInput.Builder()
        .withName(task.name)
        .withGroupName(task.groupName)
        .withReadableName(task.readableName)
        .withDescription(task.description)
        .withCategory(task.category)
        .withImageUrl(task.imageUrl)
        .withCpu(task.cpu)
        .withMemory(task.memory)
        .withTimeout(task.timeout)
        .withParams(task.params || [])
        .withMarkdownId(fid);
      return updateTaskCall({
        taskId,
        taskInput: taskInput
        .build()
        .serialize()
      })
      .then(() => queryClient.invalidateQueries({ queryKey: DataScienceQuery.KEYS.SEARCH_TASKS() }))
  }

  return {
    onChange,
    ON_CHANGE,
    updateTaskMarkdown
  }
})()